import { render, staticRenderFns } from "./clipIcon.vue?vue&type=template&id=365685ec&"
import script from "./clipIcon.vue?vue&type=script&lang=js&"
export * from "./clipIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports